import * as React from 'react';
import AuthContext from 'Context/AuthContext';
import { TransactionsHistoryHandler } from './TransactionsHistoryHandler';
import { Table, Row, Col, Input, DatePicker, Button, Icon, Card, List } from 'antd';
import moment, { Moment } from 'moment';
import { string } from 'prop-types';
import { RouteComponentProps, withRouter } from 'react-router';
import FormControl from 'components/Forms/FormControl';
import Form, { FormComponentProps } from 'antd/lib/form';
import { start } from 'repl';
import Utility from 'Core/Utility';
import ConfigUtility from 'Core/ConfigUtility';
import { stat } from 'fs';
import { SubmitButton } from 'components/SubmitButton';
// import ValidationUtility from 'Core/ValidationUtility';
const { RangePicker } = DatePicker;
const config = ConfigUtility.getSync();
const dateFormat = config?.Display?.DateFormat;

export interface Props extends RouteComponentProps, FormComponentProps {
  children?: React.ReactNode;
}

export interface State {
  ids?: string[];
  data: [{
    paymentId: string;
    totalInJmd: string;
    paymentDate: string;
    time: string;
    paymentMethod: string;
  }];

  filteredTransaction: [{
    paymentId: string;
    totalInJmd: string;
    paymentDate: string;
    time: string;
    paymentMethod: string;
  }];
}

class BaseTransactionsHistoryView extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  handler: TransactionsHistoryHandler;
  private columns = [
    {
      title: 'Payment Reference Number',
      dataIndex: 'paymentId',
      key: 'paymentId',
    },
    {
      title: 'Amount',
      dataIndex: 'totalInJmd',
      key: 'totalInJmd',
    },
    {
      title: 'Date',
      dataIndex: 'paymentDate',
      key: 'paymentDate',
    },
    {
      title: 'Time',
      dataIndex: 'time',
      key: 'time',
    },
    {
      title: 'Method',
      dataIndex: 'paymentMethod',
      key: 'paymentMethod',
    },
  ];
  constructor(props: Props) {
    super(props);
    this.handler = new TransactionsHistoryHandler(props);
    this.state = {
      data: [{
        paymentId: '',
        totalInJmd: '',
        paymentDate: '',
        time: '',
        paymentMethod: '',
      }],
      filteredTransaction: [{
        paymentId: '',
        totalInJmd: '',
        paymentDate: '',
        time: '',
        paymentMethod: '',
      }]
    };

    //empty filteredTransaction of intitial value before setting
    this.state.filteredTransaction.splice(0, this.state.filteredTransaction.length)

    this.filterTransactionData = this.filterTransactionData.bind(this);
  }

  componentDidMount() {
    this.handler
      .GetTransactionsHistory(this.context.data?.id ?? "")
      .then(x => {
        if (x.page) {
          const paymentIds = x.page.map(y => y.paymentId?.toString() ?? "");
          this.setState({ ids: paymentIds });
          const data: any = [{
            paymentId: string,
            totalInJmd: string,
            paymentDate: string,
            time: string,
            paymentMethod: string,
          }];
          let totalInJmd: string;
          let paymentDate: string;
          let time: string;
          let paymentMethod: string;
          let paymentId: string;

          x.page.forEach((a: any) => {
            paymentDate = Utility.ToDateString(moment(a?.paymentDate));
            time = Utility.ToTimeString(moment(a?.paymentDate));
            totalInJmd = a?.totalInJmd + ' JMD';
            paymentMethod = a?.paymentMethod;
            paymentId = a?.receiptNumber;

            data.push({
              paymentId,
              totalInJmd,
              paymentDate,
              time,
              paymentMethod,
            });
          });


          if (x.itemCount != null && x.itemCount > 0) {
            this.setState({
              data,
              filteredTransaction: data.filter(x => x.paymentId != string)
            })
          }
        }
      })
      .catch(x => console.log(x));
  }

  fieldValidator = (rule: any, value: any, callback: any) => {
    const { form } = this.props;
    var searchText = form.getFieldValue('filterText');
    var dateRange = form.getFieldValue('filterDate');
    if (!searchText && !dateRange) {
      callback('Both fields cannot be null');
    } else {
      callback();
    }
  };

  isInString = (arr, str: string) => {
    if (!str) {
      return arr;
    } else {
      return arr.map((value: string) => {
        return String(value).toLowerCase();
      }).find((value: String) => {
        return value.includes(str.toLowerCase());
      });
    }
  }
  isInDateRange = (paymentDate: Moment, start: Moment, end: Moment) => {
    return (!start && !end) ? true : paymentDate.isBetween(start, end, 'days', '[]');
  }

  filterTransactionData(e: React.FormEvent) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        const searchText = values.filterText;
        const startDate: Moment = (values.filterDate !== undefined && values.filterDate.length > 0) ? values.filterDate[0] : null;
        const endDate: Moment = (values.filterDate !== undefined && values.filterDate.length > 0) ? values.filterDate[1] : null;

        let filtered: any = [{
          paymentId: string,
          totalInJmd: string,
          paymentDate: string,
          time: string,
          paymentMethod: string,
        }];

        let transactions = [...this.state.data];
        if (!searchText && !startDate && !endDate) {
          filtered = transactions;
        } else
          filtered = transactions.filter((transaction) => {
            var paymentDate = moment(transaction.paymentDate, dateFormat);
            return (
              (this.isInDateRange(paymentDate, startDate, endDate) && this.isInString(Object.values(transaction), searchText)));
          });
        this.setState({ filteredTransaction: filtered });
      }
    });
  }

  render() {
    const data = this.state.filteredTransaction;
    const { getFieldDecorator } = this.props.form;

    return (
      <Row type="flex" justify="center" style={{ border: "solid lightgrey 2px", borderRadius: "15px", padding: "15px 20px", marginTop: "5px" }}>
        <Col span={24}>
          <Row type="flex" justify="center">
            <Col lg={{ span: 24 }}>
              <Row type="flex" justify="center">
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    name="filterText">
                    <Input placeholder="Filter Transaction History" allowClear />
                  </FormControl>
                </Col>
              </Row>
              <Row type="flex" justify="center">
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  <FormControl
                    getFieldDecorator={getFieldDecorator}
                    name="filterDate">
                    <RangePicker style={{ width: '100%' }} separator="-" placeholder={["Filter by Start Date", "Filter by End Date"]} format={dateFormat} />
                  </FormControl>
                </Col>
              </Row>
              <Row type="flex" justify="center">
                <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                  <Form.Item>
                    <SubmitButton icon="search" type="primary" htmlType="submit" onClick={this.filterTransactionData} style={{ textAlign: "center" }}>Search</SubmitButton>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            {/* <Col md={{ span: 5, offset: 0 }} lg={{ span: 2, offset: 0 }} /> */}
            {/* <Col md={{ span: 5, offset: 0 }} lg={{ span: 20, offset: 0 }}> */}
            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <List
                size="large"
                dataSource={data}
                pagination={{ pageSize: 5 }}
                renderItem={item =>
                  <div style={{ textAlign: "left", margin: 5, backgroundColor: "#f8f8f8", borderRadius: 8, padding: 10 }}>
                    <Row >
                      <Col>
                        <Row >
                          <Col span={6}>{`${moment(item.paymentDate).format("DD/MM/YYYY")} ${item.time}`} </Col>
                        </Row>
                        <Row >
                          <Col style={{ fontWeight: "bold", fontSize: 20 }} span={14}>Receipt: #{item.paymentId}</Col>
                          <Col style={{ fontWeight: "bold", fontSize: 20 }} span={10}>{item.totalInJmd}</Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                }
              />
            </Col>
          </Row>
        </Col>
      </Row >
    );
  }
}

const TransactionsHistoryViewWithoutRouter = Form.create<Props>({
  name: 'TransactionsHistoryView'
})(BaseTransactionsHistoryView);

const TransactionsHistoryView = withRouter(TransactionsHistoryViewWithoutRouter);

export default TransactionsHistoryView;